import React, { useEffect, useState } from "react";
import ORA from "../../components/ORA/ORA";
import ORAinput from "../../components/ORA_input/ORA_input";
import styles from "./ORA_Cancer.module.css";

const ORA_Cancer = () => {
  const [resultData, setResultData] = useState([]);

  const [ORAType, setORAType] = useState("Cancer");
  const [CGdbType ,setCGdbType] = useState("cancer");
  const [dbType, setDBType] = useState("");
  const [geneSetType, setGeneSetType] = useState("");
  const [geneSet, setGeneSet] = useState("");
  const [geneSetLength, setGeneSetLength] = useState(0);
  const [qValueCutoff, setQValueCutoff] = useState("");
  const [cancerLevelSet, setCancerLevelSet] = useState("");
  const [selectedFileForPathwayDB, setSelectedFileForPathwayDB] = useState(null);
  const exampleGeneset =
    "C10orf27\nEMID1\nHSPC072\nIGF2BP3\nKIF19\nSLC15A2\nSEMA3D\nBTBD17\nLOC643008\nTMEM178\nHOOK1\nFURIN\nESM1\nFGF12\nCKB\nATP7B\nGPSM1\nTMEFF1\nMMEL1\nSLC4A5\nB3GALT2\nINPP5A\nMEST\nTMEM72\nVWA5B1\nC1GALT1\nFAM171A2\nSTARD13\nC10orf107\nGGT6\nINCENP\nPLEKHG3\nKIF1A\nIYD\nAKT2\nC20orf3\nNFYC\nSEPN1\nZNF804B\nFBF1\nSAMD13\nTBC1D4\nC17orf82\nIL17D\nSHANK2\nC22orf23\nPLAGL2\nNYNRIN\nC10orf28\nTTYH2\nMINPP1\nACSF2\nMICALL1\nBFSP1\nZNF618\nLMAN2L\nCEP152\nMYCN\nKCNE3\nSLC16A14\nPRTG\nTMEM37\nPRKACB\nAKT1\nCXorf30\nATP10B\nSLC39A11\nPLA2G3\nPRDM11\nBCAM\nDLX4\nPCDHB13\nOSBP2\nPART1\nRTN4RL2\nDACH2\nCLTCL1\nDMPK\nCTRB2\nZNF433\nLRRC43\nC2orf71\nARHGAP24\nBRWD1\nCLCN2\nSTXBP5\nSSX7\nICK\nANGPT4\nEBF4\nAHDC1\nC9orf140\nULBP3\nANGPT2\nPLCH2\nRASSF10\nZCCHC3\nSTK40\nFUT10\nANK3\nALG12\nMFAP3L\nCELSR1\nZNF652\nSPEG\nDNMT3A\nLATS2\nPCDHGB2\nASXL3\nRANBP10\nMGC26647\nADAMTS3\nPRKCI\nAPBA2\nUSP2\nNECAB3\nLOC158376\nHIC2\nZDHHC15\nFREM2\nC10orf26\nACCN2\nE2F1\nKDM4B\nHIVEP3\nTLK2\nTMEM26\nSLC6A13\nMAGED2\nTXNDC12\nMGC16275\nVEGFC\nSNED1\nCOL28A1\nLAMB4\nATP1A1\nC12orf34\nTMPRSS3\nIRX5\nSMARCAL1\nCHD3\nADAMTS5\nARSK\nPIGS\nLOC442421\nDBH\nSLC12A4\nTCF7L1\nAPBB1\nCOL4A5\nLIPT2\nSCUBE3\nMAP2K4\nABI3BP\nWBSCR17\nGFRA3\nGFOD2\nTSPAN1\nLOC100129550\nRAVER2\nC17orf48\nSLC35B4\nBTRC\nEDNRB\nGGTLC1\nSIRT4\nPGAP2\nCDON\nGAL3ST3\nCASP12\nTP53I11\nGOLGA1\nTRPC6\nSLC12A8\nAGPAT4\nPPT1\nWSCD2\nTMEM150C\nIGDCC4\nIP6K3\nSLC5A6\nPRDM16\nNICN1\nRASL10B\nDKFZp779M0652\nSLC22A23\nC14orf180\nSOX12\nRGS8\nLHFPL1\nANKS1A\nARHGAP31\nC16orf46\nMRPL40\nPRAMEF16\nGHR\nCATSPERB\nDLX3\nMTMR1\nZNF454\nGPR160\nTNFAIP8L1\nLIPG\nSLC9A6";

  const [sepBtnState, setSepBtnState] = useState("");
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    localStorage.clear();
  }, []);

  useEffect(() => {
    const data = localStorage.getItem("ora");
    const parseData =
      typeof data === "string" ? JSON.parse(data) : { "1": resultData[0] };
    const arrayData = Object.values(parseData);
    data !== null && setResultData(arrayData);
  }, [loading]);

  return (
    <div className={styles.section}>
      <ORAinput
        ORAType={ORAType}
        CGdbType={CGdbType}
        setLoading={setLoading}
        dbType={dbType}
        setDBType={setDBType}
        geneSetType={geneSetType}
        setGeneSetType={setGeneSetType}
        geneSet={geneSet}
        setGeneSet={setGeneSet}
        setGeneSetLength={setGeneSetLength}
        qValueCutoff={qValueCutoff}
        setQValueCutoff={setQValueCutoff}
        setErr={setErr}
        cancerLevelSet={cancerLevelSet}
        setCancerLevelSet={setCancerLevelSet}
        setResultData={setResultData}
        sepBtnState={sepBtnState}
        setSepBtnState={setSepBtnState}
        selectedFileForPathwayDB={selectedFileForPathwayDB}
        setSelectedFileForPathwayDB={setSelectedFileForPathwayDB}
        exampleGeneset={exampleGeneset}
      />
      <ORA
        ORAType={ORAType}
        resultData={resultData}
        loading={loading}
        setLoading={setLoading}
        err={err}
        sepBtnState={sepBtnState}
        setSepBtnState={setSepBtnState}
        qValueCutoff={qValueCutoff}
      />
    </div>
  );
};
export default ORA_Cancer;
